/**
 * Normalize brand accent hex color — fallback to default purple
 */
export function normalizeBrandColor(color, fallback = '#250c4b') {
  if (!color || typeof color !== 'string') return fallback;
  const trimmed = color.trim();
  if (/^#[0-9A-Fa-f]{6}$/.test(trimmed)) return trimmed;
  if (/^[0-9A-Fa-f]{6}$/.test(trimmed)) return `#${trimmed}`;
  return fallback;
}

/** Resolve accent from brand object */
export function getBrandAccent(brand, fallback = '#250c4b') {
  return normalizeBrandColor(brand?.primaryColor, fallback);
}

/** Reusable sx tokens for brand-scoped UI */
export function brandAccentTokens(accent) {
  const color = normalizeBrandColor(accent);
  return {
    accent: color,
    softBg: `${color}14`,
    softBorder: `${color}33`,
    hoverShadow: `0 4px 16px ${color}22`,
  };
}
